import { Inject, Injectable, Optional } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ServiceRouter, LogService } from '@pershing/pershing-core';
import { TradingServiceDefinition } from '../../models/common/trading-service-definition';
import { MutualFundTradingServiceDefinition } from './../../models/mutualfund/mutualfund-trading-service-definition';
import { Observable } from 'rxjs';
import { DispositionMethod, TaxlotSubmissionRequest, TaxlotDetailsRequest } from '../../models/common/tax-lot.model';
import { TradeType } from '../../models/common/trading-common.model';

@Injectable()
export class TaxLotService {
  private taxlotServiceBaseUrl: string;
  private taxlotServiceMutualFundUrl: string;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  private platform: string;


  constructor(private http: HttpClient, private serviceRouter: ServiceRouter, private logService: LogService, @Optional() @Inject('AppSettings') appSettings: any) {
    if (appSettings?.platform) {
      this.platform = appSettings.platform;
  } else {
    this.platform = 'professional';
}
    this.taxlotServiceBaseUrl = this.serviceRouter.getServiceRouteURL(
      TradingServiceDefinition.getInstance(this.platform),
      { ignoreOptions: { serviceVersion: true } }
    );
    this.taxlotServiceMutualFundUrl = this.serviceRouter.getServiceRouteURL(MutualFundTradingServiceDefinition.getInstance(this.platform), 
    { ignoreOptions: { serviceVersion: true } });

  }

  public getTaxlotDispositionMethod(req: DispositionMethod): Observable<any> {
    let url = this.taxlotServiceBaseUrl + '/taxlot-disposition-method';
    return this.http.post(url, req, { headers: this.headers });
  }

  public submitTaxlot(req: TaxlotSubmissionRequest): Observable<any> {
    let url = req.tradeType === TradeType.MUTUAL_FUND ? this.taxlotServiceMutualFundUrl : this.taxlotServiceBaseUrl;
    return this.http.post(url + '/taxlot-submit', req, { headers: this.headers });
  }

  public getTaxlotDetails(req: TaxlotDetailsRequest): Observable<any> {
    let url = this.taxlotServiceBaseUrl + '/taxlot-details';
    return this.http.post(url, req, { headers: this.headers });
  }

}
